import {useSelector} from 'react-redux'

const useCurrentUser = () => useSelector( state => state.users.current_user)

export default useCurrentUser